module.exports = __webpack_public_path__ + "files/2df318f656aa68aeee87079e4c1e6ebd.png";